/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const LogoIcon = (props: SVGProps<SVGSVGElement>) => {
  const { fill, height } = props;
  return (
    <svg
      height={height ?? 30}
      fill={fill ?? '#000'}
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 196 209.33333"
    >
      <path
        d="M675.109 87.941 156.398 374.57v476.231l576.563 318.579 352.809-194.501v184.301l-352.809 194.91L0 948.891V285.109L515.891 0l159.218 87.941"
        style={{
          fill: '#f44336',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
        transform="matrix(.13333 0 0 -.13333 0 209.333)"
      />
      <path
        d="m1311.02 1034.68-.93-633.66-403.891-223.219-558.527 309.14.027 431.571-158.019-87.301V395.578L906.199 0l562.071 310.379V947.25l-157.25 87.43"
        style={{
          fill: '#f44336',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
        transform="matrix(.13333 0 0 -.13333 0 209.333)"
      />
      <path
        d="m189.66 1090.49 543.379 300.53 385.931-213.54-.2-676.96-362.668-200.731 149.847-82.937 370.761 204.769-.28 847.779L733.039 1570 189.66 1269.42v-178.93"
        style={{
          fill: '#f44336',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
        transform="matrix(.13333 0 0 -.13333 0 209.333)"
      />
    </svg>
  );
};

export default LogoIcon;
